module.exports = __webpack_public_path__ + "img/逆时针旋转90度.1da07cb9.svg";